import React from "react";
import { BarChart } from '@mui/x-charts/BarChart';
import { PieChart, pieArcLabelClasses } from '@mui/x-charts/PieChart';
import Toggle from 'react-toggle'
import "react-toggle/style.css" 
const sizing = {
  margin: { right: 5 },
  // width: 250, // Adjust width as needed
  height: 280, // Adjust height as needed
  legend: { hidden: true },
};


export default  ({ selectedOtherInterval, classificationData,ishowToggleClassification, setIshowToggleClassification }) => {
 
  const currentYear = new Date().getFullYear();
  const futureYears = Array.from({ length: 5 }, (_, index) => currentYear + index);
  const data = {
    daily: {
      jData: classificationData?.junior?.final_res?.length > 0 ? classificationData?.junior?.final_res : Array(31).fill(0),
      cData: classificationData?.college?.final_res?.length > 0 ? classificationData?.college?.final_res : Array(31).fill(0),
      pData: classificationData?.professional?.final_res?.length > 0 ? classificationData?.professional?.final_res : Array(31).fill(0),
      aData: classificationData?.adult_competitive?.final_res?.length > 0 ? classificationData?.adult_competitive?.final_res : Array(31).fill(0),
      sData: classificationData?.adult_social?.final_res?.length > 0 ? classificationData?.adult_social?.final_res : Array(31).fill(0),
      xLabels: Array.from({ length: 31 }, (_, index) => `Day ${index + 1}`),
    },
    weekly: {
      jData: classificationData?.junior?.final_res?.length > 0 ? classificationData?.junior?.final_res : Array(7).fill(0),
      cData: classificationData?.college?.final_res?.length > 0 ? classificationData?.college?.final_res : Array(7).fill(0),
      pData: classificationData?.professional?.final_res?.length > 0 ? classificationData?.professional?.final_res : Array(7).fill(0),
      aData: classificationData?.adult_competitive?.final_res?.length > 0 ? classificationData?.adult_competitive?.final_res : Array(7).fill(0),
      sData: classificationData?.adult_social?.final_res?.length > 0 ? classificationData?.adult_social?.final_res : Array(7).fill(0),
      xLabels: ["Week 1", "Week 2", "Week 3", "Week 4", "Week 5", "Week 6", "Week 7"],
    },
    monthly: {
      jData: classificationData?.junior?.final_res?.length > 0 ? classificationData?.junior?.final_res : Array(12).fill(0),
      cData: classificationData?.college?.final_res?.length > 0 ? classificationData?.college?.final_res : Array(12).fill(0),
      pData: classificationData?.professional?.final_res?.length > 0 ? classificationData?.professional?.final_res : Array(12).fill(0),
      aData: classificationData?.adult_competitive?.final_res?.length > 0 ? classificationData?.adult_competitive?.final_res : Array(12).fill(0),
      sData: classificationData?.adult_social?.final_res?.length > 0 ? classificationData?.adult_social?.final_res : Array(12).fill(0),
      xLabels: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    },
    yearly: {
      jData: classificationData?.junior?.final_res?.length > 0 ? classificationData?.junior?.final_res : Array(futureYears.length).fill(0),
      cData: classificationData?.college?.final_res?.length > 0 ? classificationData?.college?.final_res : Array(futureYears.length).fill(0),
      pData: classificationData?.professional?.final_res?.length > 0 ? classificationData?.professional?.final_res : Array(futureYears.length).fill(0),
      aData: classificationData?.adult_competitive?.final_res?.length > 0 ? classificationData?.adult_competitive?.final_res : Array(futureYears.length).fill(0),
      sData: classificationData?.adult_social?.final_res?.length > 0 ? classificationData?.adult_social?.final_res : Array(futureYears.length).fill(0),
      xLabels: futureYears.length > 0 ? futureYears.map(String) : [],
    },
  };
  const toogleMatchePriceShow = () => {
    setIshowToggleClassification(!ishowToggleClassification)
  }

  //for pie chart
  function convertData(originalData) {
    let convertedData = {
      data: []
    };
  
    originalData[selectedOtherInterval]?.jData?.forEach((value, index) => {
      convertedData.data.push({ value: value, label: `Junior ${originalData[selectedOtherInterval]?.xLabels[index]}`, color:"#02B2AF",});
    });
  
    originalData[selectedOtherInterval]?.cData?.forEach((value, index) => {
      convertedData.data.push({ value: value, label: `College ${originalData[selectedOtherInterval]?.xLabels[index]}`,  color:"#2E96FF", });

    });
    originalData[selectedOtherInterval]?.pData?.forEach((value, index) => {
      convertedData.data.push({ value: value, label: `Professional ${originalData[selectedOtherInterval]?.xLabels[index]}`,  color:"#B800D8", });

    });
    originalData[selectedOtherInterval]?.aData?.forEach((value, index) => {
      convertedData.data.push({ value: value, label: `Adult Competitive ${originalData[selectedOtherInterval]?.xLabels[index]}`,  color:"#60009B", });

    });
    originalData[selectedOtherInterval]?.sData?.forEach((value, index) => {
      convertedData.data.push({ value: value, label: `Adult Social ${originalData[selectedOtherInterval]?.xLabels[index]}`,  color:"#2731C8", });

    });
  
    return convertedData;
  }
  const convertedData = convertData(data);
    
      
  return (
    <div className="row">
      <div className="col-lg-12 grid-margin stretch-card">
        <div className="card">
            <div className="card-body">
                <div className="row">
                  <div className="d-flex align-items-center justify-content-between">
                    <h4 className=""><b>{!ishowToggleClassification? 'Matches played as per category' : 'Match earnings as per category'}:</b></h4>
                  </div>
                  <div className="d-flex align-items-center justify-content-between">
                    <h5 className=""><b> Junior / College / Professional / Adult Competitive / Adult Social</b></h5>
                  <div className="d-flex align-items-center justify-content-between">
                      <Toggle
                          className="form-control"
                          id='cheese-status'
                          defaultChecked={ishowToggleClassification}
                          onChange={toogleMatchePriceShow} 
                        />
                  </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                      <BarChart
                        series={[
                          { data: data[selectedOtherInterval]?.jData, label: 'Junior',  color:"#02B2AF" },
                          { data: data[selectedOtherInterval]?.cData, label: 'College', color:"#2E96FF"},
                          { data: data[selectedOtherInterval]?.pData, label: 'Professional', color:"#B800D8"},
                          { data: data[selectedOtherInterval]?.aData, label: 'Adult Competitive', color:"#60009B" },
                          { data: data[selectedOtherInterval]?.sData, label: 'Adult Social', color:"#2731C8" },
                        ]}
                        xAxis={[{ data: data[selectedOtherInterval].xLabels, scaleType: 'band' }]}
                        // width={530}
                        height={300}
                        margin={{ top: 100, right: 30, bottom: 30, left: 30 }}
                      />
                    </div>
                  <div className="col-md-6">
                      {/* <PieChart
                        series={[
                          {
                            data: data[selectedOtherInterval]?.jData?.map((value, index) => ({
                              value: value,
                              color:"#02B2AF",
                              label: (`Junior ${data[selectedOtherInterval]?.xLabels[index]}`),
                            })),
                            arcLabel: (item) => `Junior ${item.value}`,
                            arcLabelMinAngle: 45,
                          },
                          {
                            data: data[selectedOtherInterval]?.cData?.map((value, index) => ({
                              value: value,
                              color:"#2E96FF",
                              label: (`College ${data[selectedOtherInterval]?.xLabels[index]}`),
                            })),
                            innerRadius: 60,
                            arcLabel: (item) => `College ${item.value}`,
                            arcLabelMinAngle: 45,
                          },
                          {
                            // outerRadius: 135,
                            data: data[selectedOtherInterval]?.pData?.map((value, index) => ({
                              value: value,
                              color:"#B800D8",
                              label: (`Professional ${data[selectedOtherInterval]?.xLabels[index]}`),
                            })),
                            innerRadius: 40,
                              arcLabel: (item) => `Professional ${item.value}`,
                              arcLabelMinAngle: 45,
                          },
                          {
                            // outerRadius: 100,
                            data: data[selectedOtherInterval]?.aData?.map((value, index) => ({
                              value: value,
                              color:"#60009B",
                              label: (`Adult Competitive ${data[selectedOtherInterval]?.xLabels[index]}`),
                            })),
                            innerRadius: 20,
                            arcLabel: (item) => `Adult Competitive ${item.value}`,
                            arcLabelMinAngle: 45,
                          },
                          {
                            data: data[selectedOtherInterval]?.sData?.map((value, index) => ({
                              value: value,
                              color:"#2731C8",
                              label: (`Adult Social
                              ${data[selectedOtherInterval]?.xLabels[index]}`),
                            })),
                            innerRadius: 70,
                            arcLabel: (item) => `Adult Social ${item.value}`,
                            arcLabelMinAngle: 45,
                          },
                        ]}
                        sx={{
                            [`& .${pieArcLabelClasses?.root}`]: {
                                fill: 'white',
                                fontSize: 10,
                            },
                        }}
                        {...sizing}
                      /> */}
                       <PieChart
                        series={[
                          {
                            arcLabel: (item) => `${item.label} (${item.value})`,
                            arcLabelMinAngle: 45,
                            data : convertedData?.data
                          },
                        ]}
                        sx={{
                          [`& .${pieArcLabelClasses.root}`]: {
                            fill: 'white',
                            fontSize: 10,
                          },
                        }}
                        {...sizing}
                      />
                    </div>
                </div>
            </div>
          </div>
        </div>
    </div>
  )
}
